// === src/main.js ===
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import './plugins/vue-apexchart';

Vue.config.productionTip = true;

// 1) Configurar axios globalmente
//    Cargar token desde localStorage y setear Authorization correcto
const savedToken = localStorage.getItem('token');
if (savedToken) {
  axios.defaults.headers.common['Authorization'] = 'Token ' + savedToken;
}

// 2) Exponer axios como this.$http en los componentes
Vue.prototype.$http = axios;

// 3) Interceptor para adjuntar ?anio=YYYY a cada request
const YEAR_PARAM = 'anio'; // si la API cambia a ?year=, modifica aquí

function attachYear(config) {
  try {
    const y = store.getters['filters/selectedYear'];
    if (y) {
      config.params = config.params || {};
      if (!(YEAR_PARAM in config.params)) {
        config.params[YEAR_PARAM] = y;
      }
    }
  } catch (e) {
    // silencioso para no romper requests si aún no existe el módulo filters
    // console.error('Error attachYear:', e);
  }
  return config;
}

// Usamos la MISMA instancia de axios en todos lados
axios.interceptors.request.use(attachYear, err => Promise.reject(err));

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
